import { Selector } from '@ngxs/store';

import { CoBrowsingCompany } from '@customer-portal/shared/models';

import { SettingsState, SettingsStateModel } from '../settings.state';

export class CoBrowsingSelectors {
  @Selector([CoBrowsingSelectors._selectedCoBrowsingCompany])
  static selectedCoBrowsingCompany(
    selectedCoBrowsingCompany: CoBrowsingCompany | null,
  ): CoBrowsingCompany | null {
    return selectedCoBrowsingCompany;
  }

  @Selector([CoBrowsingSelectors._isDnvUser])
  static isDnvUser(isDnvUser: boolean) {
    return isDnvUser;
  }

  @Selector([CoBrowsingSelectors._companySuggestions])
  static companySuggestions(
    companySuggestions: CoBrowsingCompany[],
  ): CoBrowsingCompany[] {
    return companySuggestions;
  }

  @Selector([CoBrowsingSelectors._isLoadingCompanySuggestions])
  static isLoadingCompanySuggestions(
    isLoadingCompanySuggestions: boolean,
  ): boolean {
    return isLoadingCompanySuggestions;
  }

  @Selector([CoBrowsingSelectors._companySuggestionError])
  static companySuggestionError(companySuggestionError: string): string {
    return companySuggestionError;
  }

  @Selector([SettingsState])
  private static _companySuggestionError(state: SettingsStateModel): string {
    return state.companySuggestion.error;
  }

  @Selector([SettingsState])
  private static _isLoadingCompanySuggestions(
    state: SettingsStateModel,
  ): boolean {
    return state.companySuggestion.isLoading;
  }

  @Selector([SettingsState])
  private static _companySuggestions(
    state: SettingsStateModel,
  ): CoBrowsingCompany[] {
    return state.companySuggestion.suggestionList;
  }

  @Selector([SettingsState])
  private static _selectedCoBrowsingCompany(
    state: SettingsStateModel,
  ): CoBrowsingCompany | null {
    return state.selectedCoBrowsingCompany;
  }

  @Selector([SettingsState])
  private static _isDnvUser(state: SettingsStateModel): boolean {
    return state.isDnvUser;
  }
}
